import React, { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';
import { Listing } from 'components/shared/TableListing';

import { DealerProfitabilityListingEntity } from '../../../types';
import { useDealBuilderContext } from '../../../../dealBuilder/context';
import { DealerProfitabilityListingColumns } from './dealerProfitabilityListingConfig';

export const DealerProfitability = () => {
  const {
    pricing: { priceCalc },
  } = useDealBuilderContext();

  const {
    marginRate = 0,
    grossProfit = 0,
    totalDealerCost = 0,
    netSellingPrice = 0,
    overUnderAllowanceTotal = 0,
  } = priceCalc?.profitability ?? {};

  const tableData = useMemo<DealerProfitabilityListingEntity>(
    () => ({ netSellingPrice, totalDealerCost, grossProfit, marginRate, overUnderAllowanceTotal }),
    [netSellingPrice, totalDealerCost, grossProfit, marginRate, overUnderAllowanceTotal]
  );

  return (
    <Listing<DealerProfitabilityListingEntity>
      tableData={[tableData]}
      columns={DealerProfitabilityListingColumns}
      actionPanelTop={() => (
        <Stack>
          <Typography variant="h6" component="span">
            Dealer Profitability
          </Typography>
        </Stack>
      )}
    />
  );
};
